import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
/* ACTIONS */
const CentersActions = importer('Stores/Centers/Actions')
const DonorsActions = importer('Stores/Donors/Actions')

/* SELECT */
const { saveSignUp } = importer('Stores/Users/Select', null)
export default function * success ({ res }) {
  const list = yield res?.data
  const donor = yield select(saveSignUp)
  if (list?.length > 0 && donor) {
    yield put(DonorsActions.registerDonor(donor))
  } else {
    yield put(CentersActions.registerGetCentersFailure(Error('No centers')))
  }
}
